require(
  [],
  () => {
    'use strict';

    require(['ShowCalculator']);
  }
);

define("ShowMortgageCalculator", function(){});

